package es.subastia.di

import es.subastia.auctiondetail.AuctionDetailViewModel
import es.subastia.auctionlist.AuctionFilterViewModel
import es.subastia.auctionlist.AuctionListViewModel
import es.subastia.favorites.FavoritesViewModel
import es.subastia.navigation.Navigator
import es.subastia.profile.ProfileViewModel
import es.subastia.savedsearches.SavedSearchesViewModel
import es.subastia.splash.SplashViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val viewModule = module {
    viewModel { SplashViewModel() }
    viewModel { AuctionListViewModel(get(), get(), get(), get(), get(), get(), get()) }
    viewModel { (id: String) -> AuctionDetailViewModel(get(), get(), get(), get(), id) }
    viewModel { AuctionFilterViewModel(get(), get()) }
    viewModel { FavoritesViewModel(get(), get(), get()) }
    viewModel { ProfileViewModel(get(), get(), get(), get(), get()) }
    viewModel { SavedSearchesViewModel(get(), get(), get()) }
}

val navigationModule = module {
    single { Navigator() }
}
